'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

interface BreadcrumbItem {
  label: string;
  href: string;
}

interface BreadcrumbsProps {
  customItems?: BreadcrumbItem[];
  className?: string;
}

const Breadcrumbs = ({ customItems, className = '' }: BreadcrumbsProps) => {
  const pathname = usePathname();

  const generateBreadcrumbs = (): BreadcrumbItem[] => {
    if (customItems) return customItems;

    const pathSegments = pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [
      { label: 'Home', href: '/homepage' },
    ];

    let currentPath = '';
    pathSegments.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = segment
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      breadcrumbs.push({ label, href: currentPath });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs.length <= 1) return null;

  return (
    <nav data-component-id="src/components/common/Breadcrumbs.tsx:47:4" data-component-path="src/components/common/Breadcrumbs.tsx" data-component-line="47" data-component-end-line="80" data-component-file="Breadcrumbs.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%7D"
      aria-label="Breadcrumb"
      className={`py-4 ${className}`}
    >
      <ol data-component-id="src/components/common/Breadcrumbs.tsx:51:6" data-component-path="src/components/common/Breadcrumbs.tsx" data-component-line="51" data-component-end-line="79" data-component-file="Breadcrumbs.tsx" data-component-name="ol" data-component-content="%7B%22elementName%22%3A%22ol%22%2C%22className%22%3A%22flex%20items-center%20space-x-2%20text-sm%20font-body%22%7D" className="flex items-center space-x-2 text-sm font-body">
        {breadcrumbs.map((item, index) => {
          const isLast = index === breadcrumbs.length - 1;

          return (
            <li data-component-id="src/components/common/Breadcrumbs.tsx:56:12" data-component-path="src/components/common/Breadcrumbs.tsx" data-component-line="56" data-component-end-line="76" data-component-file="Breadcrumbs.tsx" data-component-name="li" data-component-content="%7B%22elementName%22%3A%22li%22%2C%22className%22%3A%22flex%20items-center%22%7D" key={item.href} className="flex items-center">
              {index > 0 && (
                <Icon data-component-id="src/components/common/Breadcrumbs.tsx:58:16" data-component-path="src/components/common/Breadcrumbs.tsx" data-component-line="58" data-component-end-line="62" data-component-file="Breadcrumbs.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChevronRightIcon%22%2C%22className%22%3A%22text-muted-foreground%20mx-2%22%7D"
                  name="ChevronRightIcon"
                  size={16}
                  className="text-muted-foreground mx-2"
                />
              )}
              {isLast ? (
                <span data-component-id="src/components/common/Breadcrumbs.tsx:65:16" data-component-path="src/components/common/Breadcrumbs.tsx" data-component-line="65" data-component-end-line="67" data-component-file="Breadcrumbs.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-foreground%20font-medium%22%7D" className="text-foreground font-medium" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <Link data-component-id="src/components/common/Breadcrumbs.tsx:69:16" data-component-path="src/components/common/Breadcrumbs.tsx" data-component-line="69" data-component-end-line="74" data-component-file="Breadcrumbs.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22text-muted-foreground%20hover%3Atext-primary%20transition-colors%20duration-300%22%7D"
                  href={item.href}
                  className="text-muted-foreground hover:text-primary transition-colors duration-300"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;